function sortSizeInputs(modalId) {
  let checkForLoad = setInterval(() => {
    var selector = "#" + modalId;
    let elToCheck = document.querySelector(selector);
      try {
        elToCheck = elToCheck.querySelector(
          ".variant-input-wrap[data-index='option2']"
        );
      } catch (error) {
          console.log(error)
      }
    
    if (elToCheck == undefined) {
      elToCheck = document.querySelector(
        ".variant-input-wrap[data-index='option2']"
      );
    }
    if (elToCheck) {
      clearInterval(checkForLoad);
      let checkForCategory = elToCheck.children[1];
      if (isNaN(checkForCategory.getAttribute("data-value"))) {
        sortForShirt();
      } else if (!isNaN(checkForCategory.getAttribute("data-value"))) {
        sortForPant();
      }
      function sortForPant() {
        console.log("sorting for pant...");
        let allVariantInputs = elToCheck.children;
        let allElements = [];
        Array.from(allVariantInputs).forEach((item) => {
          if (item.getAttribute("data-index") === "option2") {
            allElements.push(item);
          }
        });
        console.log(allElements);
        allElements.sort(function (a, b) {
          return a.getAttribute("data-value") - b.getAttribute("data-value");
        });
        console.log(allElements);
        let variantInputWrap = elToCheck;
        variantInputWrap.innerHTML = "";
        allElements.forEach((el) => {
          console.log(el);
          variantInputWrap.append(el);
        });
        variantInputWrap.setAttribute("style", "display: block !important");
        variantInputWrap.parentElement.setAttribute(
          "style",
          "display: block !important"
        );
      }
      function sortForShirt() {
        console.log("sorting for shirt...");
        let allVariantInputs = elToCheck.children;
        let allElements = [];
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "XXS"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "XS"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "S"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "M"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "L"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "XL"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "XXL"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "XXXL"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "XXXXL"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "4XL"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "5XL"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "XXXXXL"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "6XL"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "7XL"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "8XL"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "TGU"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "onesize"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "UNICA"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "1-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "12-61"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "13-60"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "15-58"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-52"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-56"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-56"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-58"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-52"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-56"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-57"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-59"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-49"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-51"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-52"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-53"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-54"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-55"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-58"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-52"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-55"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-52"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-54"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "24-51"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "1-1-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "11-62-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "12-57-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "13-35-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "13-60-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "14-60-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "15-54-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "15-63-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "15-54-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-53-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-54-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-55-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-56-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-59-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-53-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-54-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-55-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-56-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-55-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-61-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16-64-130"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-65-125"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-52-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-53-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-54-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-55-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-57-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-51-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-52-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-54-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-55-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-56-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-57-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-58-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-56-150"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "17-58-150"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-60-135"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-51-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-52-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-53-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-54-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-55-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-56-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-57-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-51-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-52-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-53-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-54-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-56-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18-58-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-51-135"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-51-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-53-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-54-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-58-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-51-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-52-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-53-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-54-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-55-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "19-60-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-59-125"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-50-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-52-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-53-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-49-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-50-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-51-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-52-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-53-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "20-56-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-50-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-52-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-54-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-49-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-50-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-51-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-52-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-53-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-54-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "21-52-150"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "22-51-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "22-54-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "22-49-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "22-50-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "22-51-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "22-53-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "23-54-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "23-46-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "23-48-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "23-49-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "23-50-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "24-48-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "24-49-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "24-53-140"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "25-41-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "25-48-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "28-48-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "31-46-145"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "1M"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "3M"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "6M"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "9M"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "12M"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "18M"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "24M"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "36M"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "2Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "3Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "4Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "5Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "6Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "7Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "8Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "9Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "10Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "12Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "14Y"
          ) {
            allElements.push(item);
          }
        });
        Array.from(allVariantInputs).forEach((item) => {
          if (
            item.getAttribute("data-index") === "option2" &&
            item.getAttribute("data-value") === "16Y"
          ) {
            allElements.push(item);
          }
        });
        console.log(allElements);
        let variantInputWrap = elToCheck;
        variantInputWrap.innerHTML = "";
        allElements.forEach((el) => {
          variantInputWrap.append(el);
        });
        variantInputWrap.setAttribute("style", "display: block !important");
        variantInputWrap.parentElement.setAttribute(
          "style",
          "display: block !important"
        );
      }
    }
  }, 1000);
}
